import React, { useState, useEffect } from 'react';
import axios from 'axios';
import summaryApi from '../common/index';

const ManageOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios({
          url: summaryApi.getUserOrders.url,
          method: summaryApi.getUserOrders.method,
          withCredentials: true,
        });
        setOrders(response.data.data);
        setLoading(false);
      } catch (error) {
        setError(error.response?.data?.message || error.message);
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const updateOrderStatus = async (orderId, status) => {
    try {
      const response = await axios({
        url: summaryApi.updateOrderStatus.url,
        method: summaryApi.updateOrderStatus.method,
        data: { orderId, status },
        withCredentials: true,
      });
      setOrders(prevOrders =>
        prevOrders.map(order =>
          order._id === orderId ? { ...order, status: response.data.data.status } : order
        )
      );
    } catch (error) {
      setError(error.response?.data?.message || error.message);
    }
  };

  if (loading) return <p className="text-center text-gray-500 py-10">Loading...</p>;
  if (error) return <p className="text-center text-red-500 py-10">Error: {error}</p>;

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h2 className="text-3xl font-bold text-gray-700 mb-8 text-center">Manage Orders</h2>

      {orders.length === 0 ? (
        <p className="text-center text-gray-500 text-lg">No orders found</p>
      ) : (
        <div className="space-y-6">
          {orders.map((order) => (
            <div
              key={order._id}
              className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300"
            >
              {/* Order Header */}
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-1">
                    Order ID: {order._id}
                  </h3>
                  <p className="text-gray-500 text-sm">
                    Ordered on: {new Date(order.createdAt).toLocaleString()}
                  </p>
                </div>
                <div>
                  <select
                    className={`px-3 py-1 rounded font-medium ${
                      order.status === 'Pending'
                        ? 'bg-yellow-100 text-yellow-800'
                        : order.status === 'Shipped'
                        ? 'bg-blue-100 text-blue-800'
                        : order.status === 'Delivered'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    }`}
                    value={order.status}
                    onChange={(e) => updateOrderStatus(order._id, e.target.value)}
                  >
                    <option value="Pending">Pending</option>
                    <option value="Shipped">Shipped</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>
                </div>
              </div>

              {/* Items Table */}
              <div className="overflow-x-auto mb-4">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="bg-gray-100 text-gray-700">
                      <th className="py-2 px-3 border">Product</th>
                      <th className="py-2 px-3 border">Brand</th>
                      <th className="py-2 px-3 border">Quantity</th>
                      <th className="py-2 px-3 border">Price £(GBP)</th>
                      <th className="py-2 px-3 border">Total £(GBP)</th>
                    </tr>
                  </thead>
 <tbody>
  {order.items.map((item) => (
    <tr key={item._id} className="text-gray-700">
      <td className="py-2 px-3 border">{item.name}</td>
      <td className="py-2 px-3 border">{item.brandName || "N/A"}</td>
      <td className="py-2 px-3 border">{item.quantity}</td>
      <td className="py-2 px-3 border">{item.price.toLocaleString("en-IN")}</td>
      <td className="py-2 px-3 border">
        {(item.price * item.quantity).toLocaleString("en-IN")}
      </td>
    </tr>
  ))}
</tbody>


                </table>
              </div>

              {/* Delivery Address */}
              <div className="mb-4">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">Delivery Address</h4>
                <p className="text-gray-600">
                  {order.deliveryAddress.firstName} {order.deliveryAddress.lastName}
                  {order.deliveryAddress.company ? `, ${order.deliveryAddress.company}` : ''}
                </p>
                <p className="text-gray-600">
                  {order.deliveryAddress.street}
                  {order.deliveryAddress.apartment ? `, ${order.deliveryAddress.apartment}` : ''}
                </p>
                <p className="text-gray-600">
                  {order.deliveryAddress.city}, {order.deliveryAddress.postalCode}
                </p>
                <p className="text-gray-600">{order.deliveryAddress.country}</p>
                <p className="text-gray-600">Phone: {order.deliveryAddress.phone}</p>
              </div>

              {/* Total Amount */}
              <div className="text-right">
                <span className="text-lg font-semibold text-gray-800">
                  Total Amount: £ {order.totalAmount.toLocaleString('en-IN')}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ManageOrders;
